import { useRecoilValue } from 'recoil';
import {
    selectedROIState,
    structureIsolationActiveState,
} from '~/state/atoms/structureSet/roiAtoms';

/**
 * The structure the DVH chart draws emphasized, dimming the others: the
 * selected structure while structure isolation is on, or none.
 */
export function useEmphasizedRoiNumber(): number | undefined {
    const selectedRoi = useRecoilValue(selectedROIState);
    const isolationActive = useRecoilValue(structureIsolationActiveState);
    return isolationActive && selectedRoi >= 0 ? selectedRoi : undefined;
}
